import { fromJS } from 'immutable';

const postPropsReducer = (state = fromJS({})) => state;

export type Request = { req?: { body?: unknown } & { [key: string]: unknown } };

postPropsReducer.buildInitialState = ({ req }: Request = {}) => {
  if (req && req.body) {
    return fromJS({ ...req.body });
  }
  return fromJS({});
};

export default postPropsReducer;
